import * as THREE from 'three';

import Store from '../../Store';

// shaders
import fragmentReveal from "../../shaders/fragment_reveal.glsl";
import vertexReveal from "../../shaders/vertex_reveal.glsl";
import fragmentRevealNotes from "../../shaders/fragment_reveal_notes.glsl";
import vertexRevealNotes from "../../shaders/vertex_reveal_notes.glsl";
import fragmentDust2D from "../../shaders/fragment_dust2d.glsl";
import vertexDust2D from "../../shaders/vertex_dust2d.glsl";


const dustColor = new THREE.Color("#afad94");

const textureLoader = new THREE.TextureLoader();

const loadTextureProgressively = (urls, material, uniformName) => {
  let index = 0;

  const onTextureLoad = (texture) => {
    material.uniforms[uniformName].value = texture;

    index++;

    if (index < urls.length) {
      textureLoader.load(urls[index], onTextureLoad);
    }
  };

  textureLoader.load(urls[index], onTextureLoad);
};





export default class LoadingScreen {
  constructor() {
    this.scene = new THREE.Scene();

    // init the load fx
    this.initLoadingScreen();
  }

  textFadeIn() {
    const titleouter = document.getElementById("title-outer");
    const title = document.getElementById("loading-title");
    const title2 = document.getElementById("loading-title2");
    const subtitle = document.getElementById("loading-subtitle");

    titleouter.classList.add("animate__animated")
    titleouter.classList.add("animate__fadeIn");
    titleouter.classList.add("animate__fast");
    titleouter.classList.remove("opacity-0");

    setTimeout(() => {
      title.classList.add("animate__animated")
      title.classList.add("animate__fadeIn");
      title.classList.add("animate__fast");
    }, 500);

    setTimeout(() => {
      title2.classList.add("animate__animated")
      title2.classList.add("animate__fadeIn");
      title2.classList.add("animate__fast");
      this.textAnimateGlow(this._textAnimateGlow);
    }, 1000);

    setTimeout(() => {
      subtitle.classList.add("animate__animated")
      subtitle.classList.add("animate__fadeIn");
    }, 2000);

  } 

  buttonsFadeIn() {
    const loadingNotification = document.getElementById("loading-text-notification");
    loadingNotification.classList.remove("opacity-50")
    loadingNotification.classList.add("opacity-0")
    // loadingNotification.classList.add("animate__animated");
    // loadingNotification.classList.add("animate__fadeOut");

    const buttons = document.getElementById("loading-action-buttons");
    buttons.classList.add("animate__animated")
    buttons.classList.add("animate__fadeIn");

    this.buttonsRunDecryptFx();
  }

  buttonsRunDecryptFx() {}

  textAnimateGlow(callback) {
    const duration = 2000;
    let progress = 0;

    const titleOuter = document.getElementById("title-outer");

    const interval = setInterval(() => {
      progress += 20;
      const factor = progress / duration;

      titleOuter.style.textShadow = `0px 0px ${21*factor}px #c4bb9c`; 

      if (progress >= duration) {
        clearInterval(interval);
        if (callback) callback();
      }
    }, 20);    
  }

  _textAnimateGlow(callback) {
    const titleOuter = document.getElementById("title-outer");
    let time = 0;
    const interval = setInterval(() => {
      time += 0.3;
      const factor = 5 * Math.sin(time * Math.PI / 5);
      titleOuter.style.textShadow = `0px 0px ${21+factor}px #c4bb9c`; 
    }, 100);    
  }

  initLoadingScreen() {
    // setTimeout(() => {
    //   this.textFadeIn()
    // }, 1500);

    // setTimeout(() => {
    //   this.buttonsFadeIn()
    // }, 5000);
  }

  loadingFinished() {
    this.buttonsFadeIn()
  }

  destroy() {
  }
}
